module.exports = __webpack_public_path__ + "static/media/Logo lingkar antarnusa.c5aa2b8d.png";